import React from 'react'
import * as S from './Suffix.styles'

export default ({ children, suffix }) => (
  <S.SuffixWrap>
    {children}
    <S.Suffix>{suffix}</S.Suffix>
  </S.SuffixWrap>
)
